/* eslint-disable @angular-eslint/no-output-on-prefix */
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RxIconModule } from '@nrwl/rx-icon';
import { RxCheckboxModule } from '@nrwl/rx-checkbox';
import { RxPipesModule } from '@nrwl/rx-pipes';
import { RxSearchModule } from '@nrwl/rx-ui';

@Component({
  selector: 'rx-upload-thumb-group-list',
  templateUrl: './rx-upload-thumb-group-list.component.html',
  styleUrls: ['./rx-upload-thumb-group-list.component.scss'],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RxPipesModule,
    RxCheckboxModule,
    RxSearchModule,
    RxIconModule,
    RxCheckboxModule,
  ],
})
export class RxUploadThumbGroupListComponent implements OnInit {
  @Input() searchKey = '';
  @Input() subLabelPair: boolean;
  @Input() subLabelNumber: boolean;

  @Input() selectLimit = 100;
  public viewData = <any>[];
  public selectedData = <any>[];
  @Output() onSelectImg = new EventEmitter();
  public expandedIndex = 0;
  public isBuzy: boolean;

  constructor(
    private http: HttpClient,
    private _cd: ChangeDetectorRef,
  ) {}

  ngOnInit() {
    this.isBuzy = true;
    this.getStockImages().subscribe((res) => {
      this.viewData = res as any[];
      this.isBuzy = false;
      this._cd.detectChanges();
    });
  }

  public getStockImages() {
    const src = 'assets/images/gallery-stock-img/gallery-stock-img.json';
    return this.http.get(src);
  }

  getImgPath(folder, img) {
    return `url(assets/images/gallery-stock-img/${folder}/${img})`;
  }

  expandToggle(id) {
    this.expandedIndex = this.expandedIndex === id ? 0 : id;
  }

  onSelectImage(img, folder) {
    const temp = {
      folder: folder,
      image: img,
      fullPath: `assets/images/gallery-stock-img/${folder}/${img}`,
      file: null,
      subLabel: '',
    };

    if (this.subLabelPair) {
      temp.subLabel = this.selectedData[0] ? 'After' : 'Before';
    }

    if (this.subLabelNumber) {
      temp.subLabel = `${this.selectedData.length + 1}`;
    }

    this.addSelectedImgToModel(temp);
  }

  addSelectedImgToModel(simpleModel: any) {
    const idx = this.selectedData.findIndex(
      (item) => item.image === simpleModel.image && item.folder === simpleModel.folder,
    );
    if (idx === -1) {
      this.http.get(simpleModel.fullPath, { responseType: 'blob' }).subscribe((file) => {
        simpleModel.file = new File([file as Blob], simpleModel.image, file);
        const temp = this.selectedData.slice(0, this.selectLimit - 1);
        this.selectedData = [...temp, simpleModel];
        this.onSelectImg.emit(this.selectedData);
      });
    } else {
      this.selectedData = this.selectedData
        .filter((item) => {
          return !(item.image === simpleModel.image && item.folder === simpleModel.folder);
        })
        .map((item, index) => {
          const temp = { ...item };
          if (this.subLabelPair) {
            temp.subLabel = 'Before';
          }
          if (this.subLabelNumber) {
            temp.subLabel = `${index + 1}`;
          }
          return temp;
        });
      this.onSelectImg.emit(this.selectedData);
    }
  }
}
